var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.data.newsfeed_type === "post"
      ? _c(
          "div",
          [
            _c("newsfeed-meeting", {
              attrs: {
                data: _vm.data,
                groups_follow: _vm.groups_follow,
                suppliers_follow: _vm.suppliers_follow,
                members: _vm.members,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.data.newsfeed_type === "share"
      ? _c(
          "div",
          [
            _c("newsfeed-share-meeting", {
              attrs: { data: _vm.data, members: _vm.members },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }